import { Markdown } from '@devfolioco/genesis';
import styled from 'styled-components';

export const CardWrapper = styled.div`
  margin: 1rem auto 0;
  position: relative;
  max-width: 56em;

  @media (max-width: 1024px) {
    max-width: 796px;
  }

  @media (max-width: 893px) {
    max-width: 584px;
  }
`;

export const CardContent = styled.div`
  margin: 0 80px 64px 80px;

  @media (max-width: 768px) {
    margin: 0 40px 64px 40px;
  }
`;

export const Section = styled.div`
  display: flex;
  margin-top: 48px;

  > div {
    > h4 {
      margin-bottom: 16px;
    }
  }

  > div:nth-child(1) {
    flex: 3;
  }

  > div:nth-child(2) {
    flex: 2;
    margin-left: 64px;

    > div {
      margin: 8px 0;
    }
  }

  @media (max-width: 575px) {
    flex-direction: column;
    > div:nth-child(2) {
      margin-left: 0px;
      margin-top: 40px;
    }
  }
`;

export const DetailContainer = styled.div`
  display: flex;

  > div:nth-child(1) {
    flex: 1;
    margin-top: 32px;
  }

  > div:nth-child(2) {
    flex: 1;
    margin-top: 32px;
    margin-left: 32px;
  }

  @media (max-width: 630px) {
    flex-direction: column;
    > div:nth-child(2) {
      margin-left: 0px;
    }
  }
`;

export const List = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-bottom: 0px;
  padding: 0;

  li {
    display: flex;
    flex-direction: row;
    margin-bottom: 16px;
    align-items: center;

    :last-child {
      margin-bottom: 0;
    }

    button {
      margin-right: 16px;
      cursor: default;
      flex-shrink: 0;
    }

    span {
      font-size: 17px;
      line-height: 24px;
      color: ${props => props.theme.color.grey[8]};
      font-weight: 600;

      span {
        font-size: 14px;
        line-height: 20px;
        font-weight: normal;
        color: ${props => props.theme.color.grey[7]};
      }
    }
  }
`;

export const LoggedOutHeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 64px 0;

  @media (max-width: 460px) {
    a:nth-child(2) {
      max-width: 120px;
    }
  }
`;

export const StyledMarkdown = styled(Markdown)`
  img {
    max-width: 100%;
  }
`;
